import { CSSProperties } from 'react';

export const wizardStep: { [key: string]: CSSProperties | any } = {
  containerTitle: {
    marginBottom: '0px',
  },
};
